
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcTabRow as ObcTabRowElement} from '@oicl/openbridge-webcomponents/dist/components/tab-row/tab-row.js';
 import {TabData} from '@oicl/openbridge-webcomponents/dist/components/tab-row/tab-row.js';
 export type {TabData} from '@oicl/openbridge-webcomponents/dist/components/tab-row/tab-row.js';
 

 
 export const ObcTabRow = createComponent({
   react: React,
   tagName: 'obc-tab-row',
   elementClass: ObcTabRowElement,
   events: {
     
     onTabSelected: 'tab-selected' as EventName<CustomEvent<{tab: TabData, id: string, index: number}>>,
     onTabClosed: 'tab-closed' as EventName<CustomEvent<{tab: TabData, id: string, index: number}>>,
     onAddNewTab: 'add-new-tab' as EventName<CustomEvent<void>>,
   }
  });
 
 